import UserContentItemWithLocation from '../UserContentItemWithLocation';

class UserContentBookmark extends UserContentItemWithLocation {
  static typeName = 'bookmarks';
  snippet;
  constructor(properties = {}) {
    super(...arguments);

    this.snippet = properties.snippet;
  }

  serialize() {
    const { snippet } = this;

    return {
      ...super.serialize(),

      snippet,
    };
  }

  async persist({ createMutation, deleteMutation }) {
    if (this.shouldDelete) {
      await deleteMutation({ variables: { id: this.pk } });

      return null;
    }

    const { page } = this.bookLocation;

    const {
      data: { createEpubBookmark },
    } = await createMutation({
      variables: {
        input: {
          epubId: page.book.pk,
          spineEntryIndex: page.document.index,
          // In v6 with cfi-based bookmarks, a bookmark could be created on
          // a document that follows the document with the pagebreak.
          // With page-based bookmarks in v7,
          // the bookmark is guaranteed to be exactly where the page starts,
          // and is always assigned the same document as the page
          epubPageIndex: page.index,
          cfi: this.cfi,
          snippet: this.snippet,
          ncxEntryIndex: page.marker?.index,
        },
      },
    });

    return createEpubBookmark.epubBookmark.id;
  }
}

export default UserContentBookmark;
